import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface IntakeAuthResponse {
  credentialKey: string;
  refreshToken: string;
  expiresIn: number;
  errorMessage?: string;
}

@Injectable({
  providedIn: 'root'
})
export class IntakeAuthService {
  private baseUrl = environment.apiIntakesURL + '/api/Authentication';

  constructor(private http: HttpClient) { }

  authenticate(email: string, token: string): Observable<IntakeAuthResponse> {
    const url = `${this.baseUrl}/BackofficeAuth`;
    const body = { email, token };
    return this.http.post<IntakeAuthResponse>(url, body);
  }
}
